<div edsCol edsSubGrid="layout-{{ layoutType }}" edsSubGridGap="md">
  <div class="column-1" *ngIf="fundItems && fundItems.length > 0">
    <eds-search-panel
      panelId="funds"
      [leftTitle]="fundHeader.leftTitle"
      [rightTitle]="fundHeader.rightTitle"
      [viewMoreBtnText]="fundHeader.viewMoreBtnText"
      [viewMoreBtnStyle]="this.viewMoreBtnStyle"
      (viewMoreTrigger)="onViewMore($event)"
    >
      <ng-container *ngFor="let fund of fundItems">
        <eds-thumbnail-search
          class="full-results__search-thumbnail"
          [hasBorders]="false"
          [hasShadows]="false"
          [headingLevel]="4"
          [layoutCompact]="true"
          [fundFamily]="fund.fundFamily"
          [fundName]="fund.fundName"
          [shareClasses]="fund.shareClasses"
          [titleLink]="fund.fundLink"
          (shareclassClicked)="goToFund($event)"
        >
        </eds-thumbnail-search>
      </ng-container>
    </eds-search-panel>
  </div>
  <div class="column-2" *ngIf="literatureItems && literatureItems.length > 0">
    <eds-search-panel
      panelId="literature"
      [leftTitle]="literatureHeader.leftTitle"
      [rightTitle]="literatureHeader.rightTitle"
      [viewMoreBtnText]="literatureHeader.viewMoreBtnText"
      [viewMoreBtnStyle]="this.viewMoreBtnStyle"
      (viewMoreTrigger)="onViewMore($event)"
    >
      <ng-container *ngFor="let item of literatureItems">
        <eds-thumbnail
          class="full-results__search-thumbnail"
          [hasBorders]="false"
          [hasShadows]="false"
          [headingLevel]="2"
          [layoutSearch]="true"
          [docTypeSrc]="item.docTypeSrc"
          [ctaText]="item.ctaText"
          [title]="item.title"
          [body]="item.body"
          [titleLink]="item.titleLink"
          [hasSearchIcon]="true"
          [noTitleColor]="true"
        >
        </eds-thumbnail>
      </ng-container>
    </eds-search-panel>
  </div>

  <div class="column-3" *ngIf="generalItems && generalItems.length > 0">
    <eds-search-panel
      panelId="pages"
      [leftTitle]="generalHeader.leftTitle"
      [rightTitle]="generalHeader.rightTitle"
      [viewMoreBtnText]="generalHeader.viewMoreBtnText"
      [viewMoreBtnStyle]="this.viewMoreBtnStyle"
      (viewMoreTrigger)="onViewMore($event)"
    >
      <ng-container *ngFor="let item of generalItems">
        <eds-thumbnail
          class="full-results__search-thumbnail"
          [hasBorders]="false"
          [hasShadows]="false"
          [headingLevel]="2"
          [layoutSearch]="true"
          [docTypeSrc]="item.docTypeSrc"
          [title]="item.title"
          [body]="item.body"
          [titleLink]="item.titleLink"
          [hasSearchIcon]="true"
          [noTitleColor]="true"
        >
        </eds-thumbnail>
      </ng-container>
    </eds-search-panel>
  </div>
</div>
